import { FIELD_NAME } from '../constants/form-constants';
import { vehicleEntity } from '../entities/vehicle-entity';
import { formService } from '../form-service';
import { hasCarlineFromExternalContent, hasOfertaFromExternalContent } from '../helpers/form-helpers';
import { getCarline, getCarlines } from './api/get-carlines';
import { getMarketingCode } from './api/get-marketing-code';
import { getOferta } from './api/get-ofertas';
import { externalContentManager } from './external-content';

export const setProductData = async (): Promise<any | null> => {
	formService.setFieldValue(FIELD_NAME.CARLINE, undefined);
	formService.setFieldValue(FIELD_NAME.OFERTA, undefined);
	formService.setFieldValue(FIELD_NAME.VEHICLE_PRECONFIGURATION, undefined);

	// Es obligatorio definir un carline como fallback por si no se encuentra la ofertaId
	if (hasOfertaFromExternalContent() && hasCarlineFromExternalContent()) {
		const response = await getOferta();

		if (response?.carline && response?.oferta) {
			formService.setFieldValue(FIELD_NAME.CARLINE, response.carline);
			formService.setFieldValue(FIELD_NAME.OFERTA, response.oferta);

			const marketingCode = response.oferta.configuracion?.marketingCode;
			if (marketingCode) {
				formService.setFieldValue(FIELD_NAME.MARKETING_CODE, marketingCode);
				const preconfiguration = await getMarketingCode(marketingCode);

				if (preconfiguration) {
					formService.setFieldValue(FIELD_NAME.VEHICLE_PRECONFIGURATION, preconfiguration);
				}
			}

			return response.oferta;
		}
	} else if (externalContentManager.marketingCode) {
		const marketingCode = externalContentManager.marketingCode;

		formService.setFieldValue(FIELD_NAME.MARKETING_CODE, marketingCode);
		getMarketingCode(marketingCode).then((preconfiguration) => {
			if (preconfiguration) {
				formService.setFieldValue(FIELD_NAME.VEHICLE_PRECONFIGURATION, preconfiguration);
				getCarline(vehicleEntity.carlineCode).then((carline) => {
					if (carline) {
						formService.setFieldValue(FIELD_NAME.CARLINE, carline);
					}
				});
			}
		});
	} else if (hasCarlineFromExternalContent()) {
		getCarlines().then((carlines) => {
			formService.setFieldValue(FIELD_NAME.CARLINE, carlines?.length == 1 ? carlines[0] : undefined);
		});
	}

	return null;
};
